

type DisableRuleProps = { currentMatchId: string, clean: () => void}
export const DisableRule = ({ currentMatchId, clean } : DisableRuleProps) => {
    return (<button
        key={`${currentMatchId}-clean`}
        className="match-popup-action match-popup-action-ignore"
        onClick={() => { 
            clean()
        }}
     >Ignora</button>
    )
}